/**
 * @generated SignedSource<<431fba8ea2f7b57dc82f270b48d36f07>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCriteria_query$data = {
  readonly currentUser: {
    readonly criterion: {
      readonly ageRange: {
        readonly end: {
          readonly value: number;
        } | null | undefined;
        readonly start: {
          readonly value: number;
        } | null | undefined;
      };
      readonly isLocationDealbreaker: boolean | null | undefined;
      readonly isRecentlyActive: boolean | null | undefined;
      readonly isVerified: boolean | null | undefined;
      readonly maxDistanceInKm: number | null | undefined;
      readonly maxDistanceInMi: number | null | undefined;
      readonly rowId: any;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useCriteria_query";
};
export type useCriteria_query$key = {
  readonly " $data"?: useCriteria_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCriteria_query">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCriteria_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Criterion",
          "kind": "LinkedField",
          "name": "criterion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IntRange",
              "kind": "LinkedField",
              "name": "ageRange",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntRangeBound",
                  "kind": "LinkedField",
                  "name": "start",
                  "plural": false,
                  "selections": (v0/*:: as any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntRangeBound",
                  "kind": "LinkedField",
                  "name": "end",
                  "plural": false,
                  "selections": (v0/*:: as any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRecentlyActive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLocationDealbreaker",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isVerified",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxDistanceInKm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxDistanceInMi",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "be5759d8b5b69a60d64736b40b866f5a";

export default node;
